import { Dialog, useTheme, pxToRem } from '@archipro-design/aria';
import { useRef } from 'react';
import { ShareDesignBoardDialogHeading } from '@modules/design-board/component/manage/share-design-baord/ShareDesignBoardDialogHeading';
import { ShareDesignBoardForm } from '@modules/design-board/component/manage/share-design-baord/form/ShareDesignBoardForm';
import { useDesignBoardCollaboratorsContext } from '../collaborator-overview/context/DesignBoardCollaboratorsContext';
import { ClientOnly } from 'remix-utils';

interface ShareDesignBoardDialogProps {
    open?: boolean;
}

const ShareDesignBoardDialog = ({
    open = false,
}: ShareDesignBoardDialogProps) => {
    const dialogRef = useRef<HTMLDivElement>(null);
    const theme = useTheme();
    const boardContext = useDesignBoardCollaboratorsContext();
    const onCancel = () => {
        boardContext.dispatch({
            type: 'closeShareBoardModal',
        });
    };

    return (
        <ClientOnly fallback={null}>
            {() => (
                <Dialog
                    open={open}
                    ref={dialogRef}
                    trapFocus={false}
                    onCancel={onCancel}
                    closeOnOutsideClick={true}
                    header={{
                        content: <ShareDesignBoardDialogHeading />,
                        style: {
                            marginTop: pxToRem(65),
                            marginLeft: pxToRem(28),
                        },
                    }}
                    content={{
                        content: <ShareDesignBoardForm onCancel={onCancel} />,
                        style: {
                            borderTop: 'none',
                            paddingTop: pxToRem(12),
                            height: '100%',
                            paddingBottom: 0,
                            marginTop: 0,
                            marginBottom: 0,
                        },
                    }}
                    footer={{
                        style: { display: 'none' },
                    }}
                    overlay={{
                        style: {
                            background: 'rgba(0, 0, 0, 0.45)',
                        },
                    }}
                    style={{
                        overflow: 'hidden',
                        width: pxToRem(620),
                        height: pxToRem(728),
                        borderRadius: 0,
                        marginBottom: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        background: theme.siteVariables.colors.white['FFF'],
                    }}
                />
            )}
        </ClientOnly>
    );
};

export { ShareDesignBoardDialog };
